// Libraries
import React from 'react';

// Supermove

// App
import Callout from '@shared/design/components/Callout';
import Text from '@shared/design/components/Text';

const NoAvailablePaymentMethodsCallout = () => {
  return (
    <Callout
      text={
        <Text.Body>
          To start accepting payments, set up{' '}
          <a href={'/settings/company/payments'} target={'_blank'} style={{width: '100%'}}>
            <Text.MicroLink>Supermove Payment</Text.MicroLink>.
          </a>
        </Text.Body>
      }
    />
  );
};

export default NoAvailablePaymentMethodsCallout;
